import wrench from './wrench.svg?url';
import view from './view.svg?url';
import trashCan from './trashCan.svg?url';
import trash from './trash.svg?url';
import topLeft from './topLeft.svg?url';
import tile from './tile.svg?url';
import tag from './tag.svg?url';
import steam from './steam.svg?url';
import speed from './speed.svg?url';
import sort from './sort.svg?url';
import shuffle from './shuffle.svg?url';
import showMore from './showMore.svg?url';
import show from './show.svg?url';
import shield from './shield.svg?url';
import sheet from './sheet.svg?url';
import share from './share.svg?url';
import search from './search.svg?url';
import scale from './scale.svg?url';
import refresh from './refresh.svg?url';
import question from './question.svg?url';
import profile from './profile.svg?url';
import plusFilled from './plusFilled.svg?url';
import playOutlined from './playOutlined.svg?url';
import playFilled from './playFilled.svg?url';
import pencil from './pencil.svg?url';
import paper from './paper.svg?url';
import music from './music.svg?url';
import minusFilled from './minusFilled.svg?url';
import loading from './loading.svg?url';
import list from './list.svg?url';
import identityCard from './identityCard.svg?url';
import hide from './hide.svg?url';
import help from './help.svg?url';
import heartOutlined from './heartOutlined.svg?url';
import heart from './heart.svg?url';
import globe from './globe.svg?url';
import fire from './fire.svg?url';
import filter from './filter.svg?url';
import fileWithUpArrow from './fileWithUpArrow.svg?url';
import fileDownload from './fileDownload.svg?url';
import external from './external.svg?url';
import expand from './expand.svg?url';
import envelope from './envelope.svg?url';
import doc from './doc.svg?url';
import discord from './discord.svg?url';
import difficulty from './difficulty.svg?url';
import creator from './creator.svg?url';
import copy from './copy.svg?url';
import cogs from './cogs.svg?url';
import close from './close.svg?url';
import chevronRight from './chevronRight.svg?url';
import chevronLeft from './chevronLeft.svg?url';
import check from './check.svg?url';
import chart from './chart.svg?url';
import category from './category.svg?url';
import calendar from './calendar.svg?url';
import bpm from './bpm.svg?url';
import bottomRight from './bottomRight.svg?url';
import bottomArrowCircleOutlined from './bottomArrowCircleOutlined.svg?url';
import at from './at.svg?url';
import add from './add.svg?url';
import accuracy from './accuracy.svg?url';
export const iconUrls = {
    wrench,
    view,
    trashCan,
    trash,
    topLeft,
    tile,
    tag,
    steam,
    speed,
    sort,
    shuffle,
    showMore,
    show,
    shield,
    sheet,
    share,
    search,
    scale,
    refresh,
    question,
    profile,
    plusFilled,
    playOutlined,
    playFilled,
    pencil,
    paper,
    music,
    minusFilled,
    loading,
    list,
    identityCard,
    hide,
    help,
    heartOutlined,
    heart,
    globe,
    fire,
    filter,
    fileWithUpArrow,
    fileDownload,
    external,
    expand,
    envelope,
    doc,
    discord,
    difficulty,
    creator,
    copy,
    cogs,
    close,
    chevronRight,
    chevronLeft,
    check,
    chart,
    category,
    calendar,
    bpm,
    bottomRight,
    bottomArrowCircleOutlined,
    at,
    add,
    accuracy
};
export const iconNames = [
    'wrench',
    'view',
    'trashCan',
    'trash',
    'topLeft',
    'tile',
    'tag',
    'steam',
    'speed',
    'sort',
    'shuffle',
    'showMore',
    'show',
    'shield',
    'sheet',
    'share',
    'search',
    'scale',
    'refresh',
    'question',
    'profile',
    'plusFilled',
    'playOutlined',
    'playFilled',
    'pencil',
    'paper',
    'music',
    'minusFilled',
    'loading',
    'list',
    'identityCard',
    'hide',
    'help',
    'heartOutlined',
    'heart',
    'globe',
    'fire',
    'filter',
    'fileWithUpArrow',
    'fileDownload',
    'external',
    'expand',
    'envelope',
    'doc',
    'discord',
    'difficulty',
    'creator',
    'copy',
    'cogs',
    'close',
    'chevronRight',
    'chevronLeft',
    'check',
    'chart',
    'category',
    'calendar',
    'bpm',
    'bottomRight',
    'bottomArrowCircleOutlined',
    'at',
    'add',
    'accuracy'
];
